/*-----------------------------------------------------------------------------------

 Template Name: katie
 Template URI: themes.pixelstrap.com/Katie
 Description: This is Ecommerce website
 Author: Pixelstrap
 Author URI: https://themeforest.net/user/pixelstrap

 ----------------------------------------------------------------------------------- */
// 01. Header responsive
// 02. Toggle nav
// 03. Ratio js
// 04. Sticky Header js
// 05. footer year
// 06. footer accordion
// 07. Countdown js
// 08. Compare Product js
// 09. Image Zoom
// 10. Add to Cart
// 11. Wishlist js
// 12. Toast Alert
// 13. Skeleton Loader
// 14. Cursor
// 15. Tooltip
// 16. Discount Code
// 17. Currency Symbol
// 18. Color Swatch 

/*========================
    Header responsive 
==========================*/

  document.addEventListener("DOMContentLoaded", () => {
  function handleNavClick(event) {
    const clickedElement = event.target.closest("li");

    if (clickedElement && !clickedElement.classList.contains("mobile-back")) {
      const isActive = clickedElement.classList.contains("show");

      // Remove 'show' class from all <li> elements
      document.querySelectorAll("#sm-horizontal li").forEach((li) => {
        li.classList.remove("show");
        if (li.querySelector(".nav-link")) {
          li.querySelector(".nav-link").classList.remove("show");
        }
        if (li.querySelector(".mega-menu")) {
          li.querySelector(".mega-menu").classList.remove("show");
        }
        if (li.querySelector(".nav-submenu")) {
          li.querySelector(".nav-submenu").classList.remove("show");
        }
      });

      // If the clicked element didn't have the 'show' class, add it
      if (!isActive) {
        clickedElement.classList.add("show");
        if (clickedElement.querySelector(".nav-link")) {
          clickedElement.querySelector(".nav-link").classList.add("show");
        }
        if (clickedElement.querySelector(".mega-menu")) {
          clickedElement.querySelector(".mega-menu").classList.add("show");
        }
        if (clickedElement.querySelector(".nav-submenu")) {
          clickedElement.querySelector(".nav-submenu").classList.add("show");
        }
      }
    }
  }

  function handleResize() {
    if (window.innerWidth <= 1200) {
      document
        .getElementById("sm-horizontal")
        .addEventListener("click", handleNavClick);
    } else {
      document
        .getElementById("sm-horizontal")
        .removeEventListener("click", handleNavClick);
      // Remove 'show' class from all elements on resize above 1199px
      document.querySelectorAll("#sm-horizontal li").forEach((li) => {
        li.classList.remove("show");
        if (li.querySelector(".nav-link")) {
          li.querySelector(".nav-link").classList.remove("show");
        }
        if (li.querySelector(".mega-menu")) {
          li.querySelector(".mega-menu").classList.remove("show");
        }
        if (li.querySelector(".nav-submenu")) {
          li.querySelector(".nav-submenu").classList.remove("show");
        }
      });
    }
  }

  // Initial check
  handleResize();

  // Attach resize event listener
  window.addEventListener("resize", handleResize);
});


/*==========================
    Toggle nav
============================*/
const toggleNav = document.getElementById("toggle-nav");
const mobileBack = document.getElementById("mobile-back");
const smHorizontal = document.getElementById("sm-horizontal");
const mobileBackdrop = document.getElementById("mobile-backdrop");

toggleNav.addEventListener("click", function () {
  smHorizontal.classList.add("open");
  mobileBackdrop.style.display = "block";
  document.body.classList.add("overflow-y-hidden");
});

mobileBack.addEventListener("click", function () {
  smHorizontal.classList.remove("open");
  mobileBackdrop.style.display = "none";
  document.body.classList.remove("overflow-y-hidden");
});

// Hide the backdrop if clicked
mobileBackdrop.addEventListener("click", function () {
  smHorizontal.classList.remove("open");
  mobileBackdrop.style.display = "none";
});

/*====================
    Ratio js
=======================*/
document.addEventListener("DOMContentLoaded", () => {
  const bgImg = document.querySelectorAll(".bg-img");
  for (let i = 0; i < bgImg.length; i++) {
    let bgImgEl = bgImg[i];

    if (bgImgEl.classList.contains("bg-top")) {
      bgImgEl.parentNode.classList.add("b-top");
    } else if (bgImgEl.classList.contains("bg-bottom")) {
      bgImgEl.parentNode.classList.add("b-bottom");
    } else if (bgImgEl.classList.contains("bg-center")) {
      bgImgEl.parentNode.classList.add("b-center");
    } else if (bgImgEl.classList.contains("bg-left")) {
      bgImgEl.parentNode.classList.add("b-left");
    } else if (bgImgEl.classList.contains("bg-right")) {
      bgImgEl.parentNode.classList.add("b-right");
    }

    if (bgImgEl.classList.contains("blur-up")) {
      bgImgEl.parentNode.classList.add("blur-up", "lazyloaded");
    }

    if (bgImgEl.classList.contains("bg_size_content")) {
      bgImgEl.parentNode.classList.add("b_size_content");
    }

    bgImgEl.parentNode.classList.add("bg-size");
    const bgSrc = bgImgEl.src;
    bgImgEl.style.display = "none";
    bgImgEl.parentNode.setAttribute(
      "style",
      `
        background-image: url(${bgSrc});
        background-size:cover;
        background-position: center;
        background-repeat: no-repeat;
        display: block;
        `
    );
  }
});

/*======================
     Sticky Header js
========================*/


/*====================
    footer year
=======================*/
const currentYear = new Date().getFullYear();
document.getElementById("current-year").textContent = currentYear;

/*====================
    footer accordion
=======================*/

const footerButton = document.querySelectorAll(".footer-content h5");
const showNav = document.querySelector(".nav");
for (var i = 0; i < footerButton.length; ++i) {
  footerButton[i].addEventListener("click", function () {
    this.parentNode.classList.toggle("open");
  });
}

/*======================
    Countdown js
========================*/
function getTimeRemaining(endtime) {
  var t = Date.parse(endtime) - Date.parse(new Date());
  var seconds = Math.floor((t / 1000) % 60);
  var minutes = Math.floor((t / 1000 / 60) % 60);
  var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
  var days = Math.floor(t / (1000 * 60 * 60 * 24));

  return {
    total: t,
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
  };
}

function initializeClock(className) {
  var clocks = document.getElementsByClassName(className);
  Array.prototype.forEach.call(clocks, function (clock) {
    var endtime = clock.dataset.endtime;

    var countdownDiv = clock.closest(".countdown"); // Get the closest .countdown parent
    var daysSpan = clock.querySelector(".days");
    var hoursSpan = clock.querySelector(".hours");
    var minutesSpan = clock.querySelector(".minutes");
    var secondsSpan = clock.querySelector(".seconds");

    function updateClock() {
      var t = getTimeRemaining(endtime);

      if (t.total <= 0) {
        // Hide the countdown div if time is negative
        countdownDiv.style.display = "none";
        clearInterval(timeinterval);
        return;
      }

      // Update the clock values with zero-padding for all components
      daysSpan.innerHTML = t.days >= 0 ? ("0" + t.days).slice(-2) : "";
      hoursSpan.innerHTML = t.hours >= 0 ? ("0" + t.hours).slice(-2) : "";
      minutesSpan.innerHTML = t.minutes >= 0 ? ("0" + t.minutes).slice(-2) : "";
      secondsSpan.innerHTML = t.seconds >= 0 ? ("0" + t.seconds).slice(-2) : "";
    }

    updateClock();
    var timeinterval = setInterval(updateClock, 1000);
  });
}

initializeClock("clockdiv");


/*======================
    Compare Product js
========================*/
document.addEventListener("DOMContentLoaded", function () {
  var products = loadProducts();
  const currencySymbol = getCurrentCurrencySymbol();

  if (products.length > 0) {
    products.forEach((product) => {
      loadProductDetails(product.handle);
    });
  } else {
    document.getElementById("compare-empty-message").classList.remove("d-none");
  }

  document
    .querySelectorAll(
      '[data-bs-toggle="modal"][data-bs-target="#compareModal"]'
    )
    .forEach((button) => {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        console.log("clicked");
        document.getElementById("compare-products").classList.remove("d-none");

        var productTitle = this.getAttribute("data-product-title");
        console.log(productTitle);
        var productHandle = generateHandleFromTitle(productTitle);

        if (products.length >= 3) {
          showAlert(
            "You can only add up to 3 products to your compare.", "warning");
          return;
        }

        if (
          productHandle &&
          !products.some((p) => p.handle === productHandle)
        ) {
          $.getJSON(`/products/${productHandle}.js`, function (data) {
            var product = {
              id: data.id,
              handle: productHandle,
            };
            products.push(product);
            saveProducts(products);
            loadProductDetails(productHandle);
            document
              .getElementById("compare-empty-message")
              .classList.add("d-none");
          }).fail(function (jqXHR, textStatus, errorThrown) {
            console.error(
              "Error fetching product details:",
              textStatus,
              errorThrown
            );
          });
        }
      });
    });

  function generateHandleFromTitle(title) {
    return title
      .toLowerCase()
      .replace(/\+/g, "") 
      .replace(/\s+/g, "-")
      .replace(/[^\w\-]/g, "");
  }
  function formatDate(dateString) {
    if (!dateString) {
      return "Unknown date"; 
    }
    var date = new Date(dateString);

    if (isNaN(date)) {
      return "Invalid date"; 
    }

    var options = { year: "numeric", month: "long", day: "numeric" };
    return new Intl.DateTimeFormat("en-GB", options).format(date);
  }

  function loadProductDetails(productHandle) {
    $.getJSON(`/products/${productHandle}.js`, function (data) {
      var product = data;

      var formattedDate = formatDate(product.created_at);

      var availabilityText = product.available ? "In Stock" : "Out of Stock";

      document.getElementById("product-details").innerHTML += `
          <td>
            <div class="product-box">
              <div class="product-image">
                <a class="w-100" href="${product.url}">
                  <img class="img-fluid" src="${product.featured_image}" alt="${
        product.title
      }">
                </a>
              </div>
              <div class="product-details">
                <div class="product-title">
                  <h6>${product.title}11</h6>
                </div>
                <span>${currencySymbol}${(product.price / 100).toFixed(2)} <del> ${currencySymbol}${(
        product.compare_at_price / 100
      ).toFixed(2)} </del></span>
                ${product.description}
                <a href="${product.url}">More Details...</a>
                <button class="btn btn_black sm rounded compare-cart-btn" href="#" data-variant-id="${
                  product.variants[0].id
                }">
                  Add To Cart<i class="arrow"></i>
                </button>
              </div>
            </div>
          </td>
      `;

      document.getElementById("product-rating").innerHTML += `
           <td>
              <div class="rating justify-content-center">
                <div class="custom-vstar-rating-widget" product-id="${product.id}"></div>
              </div>
            </td>      
      `;
      document.getElementById("product-vendor").innerHTML += `
          <td>${product.vendor}</td>  
      `;
      document.getElementById("product-type").innerHTML += `
          <td>${product.type}</td>
      `;
      document.getElementById("product-date").innerHTML += `
          <td>${formattedDate}</td>      
      `;
      document.getElementById("product-action").innerHTML += `
          <td class="remove">
            <a class="remove-btn" href="#" onclick="removeProduct(${product.id})">
              <i class="iconsax" data-icon="trash">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M18.85 9.14001L18.2 19.21C18.09 20.78 18 22 15.21 22H8.79002C6.00002 22 5.91002 20.78 5.80002 19.21L5.15002 9.14001" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M10.33 16.5H13.66" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M9.5 12.5H14.5" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </i>
            </a>
          </td>
      `;

      // Attach the add-to-cart event listener
      document.querySelectorAll(".compare-cart-btn").forEach((button) => {
        button.addEventListener("click", function (event) {
          event.preventDefault();
          var variantId = button.getAttribute("data-variant-id");
          addToCart(variantId);
        });
      });
    }).fail(function (jqXHR, textStatus, errorThrown) {
      console.error("Error fetching product details:", textStatus, errorThrown);
    });
  }

  function refreshTable() {
    document.getElementById("product-details").innerHTML = "";
    document.getElementById("product-rating").innerHTML = "";
    document.getElementById("product-vendor").innerHTML = "";
    document.getElementById("product-type").innerHTML = "";
    document.getElementById("product-date").innerHTML = "";
    document.getElementById("product-action").innerHTML = "";

    if (products.length === 0) {
      document
        .getElementById("compare-empty-message")
        .classList.remove("d-none");
      document.getElementById("compare-products").classList.add("d-none");
    } else {
      document.getElementById("compare-empty-message").classList.add("d-none");
      document.getElementById("compare-products").classList.remove("d-none");
      products.forEach((product) => {
        loadProductDetails(product.handle);
      });
    }
  }

  function loadProducts() {
    var storedProducts = localStorage.getItem("compareProducts");
    return storedProducts ? JSON.parse(storedProducts) : [];
  }

  function saveProducts(products) {
    localStorage.setItem("compareProducts", JSON.stringify(products));
  }

  function removeProduct(productId) {
    var productIndex = products.findIndex((p) => p.id === productId);
    if (productIndex > -1) {
      products.splice(productIndex, 1);
      saveProducts(products);
      refreshTable();
    }
    showAlert("Product removed from table!", "primary");
  }

  function addToCart(variantId) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Product added to cart:", data);
        showAlert("Product added to Cart!");
      })
      .catch((error) => console.error("Error adding to cart:", error));
  }

  window.removeProduct = removeProduct;
  document.getElementById("compare-products").classList.remove("d-none");
});

/*========================
    Image Zoom 
==========================*/
document.addEventListener("DOMContentLoaded", function () {
  var zoomers = document.querySelectorAll("figure.zoom");

  zoomers.forEach(function (zoomer) {
    var img = zoomer.querySelector("img");

    zoomer.addEventListener("mousemove", function (e) {
      var offsetX, offsetY, x, y;

      if (e.offsetX) {
        offsetX = e.offsetX;
        offsetY = e.offsetY;
      } else if (e.touches) {
        var rect = zoomer.getBoundingClientRect();
        offsetX = e.touches[0].pageX - rect.left;
        offsetY = e.touches[0].pageY - rect.top;
      }

      x = (offsetX / zoomer.offsetWidth) * 100;
      y = (offsetY / zoomer.offsetHeight) * 100;

      zoomer.style.backgroundImage = "url(" + img.src + ")";
      zoomer.style.backgroundSize = "200% 200%"; // Adjust zoom level
      zoomer.style.backgroundPosition = x + "% " + y + "%";
    });

    zoomer.addEventListener("mouseenter", function () {
      zoomer.classList.add("zoomed");
    });

    zoomer.addEventListener("mouseleave", function () {
      zoomer.classList.remove("zoomed");
      zoomer.style.backgroundImage = ""; // Reset background image
    });
  });
});

function zoom(e) {
  var zoomer = e.currentTarget;
  e.offsetX ? (offsetX = e.offsetX) : (offsetX = e.touches[0].pageX);
  e.offsetY ? (offsetY = e.offsetY) : (offsetX = e.touches[0].pageX);
  x = (offsetX / zoomer.offsetWidth) * 100;
  y = (offsetY / zoomer.offsetHeight) * 100;
  zoomer.style.backgroundPosition = x + "% " + y + "%";
}

/*========================
    Add to Cart 
==========================*/
document.addEventListener("DOMContentLoaded", function () {
  const addToCartButtons = document.querySelectorAll(".add-to-cart-btn");
  const addToCartButton = document.querySelectorAll(".add-to-cart");
  var modal = document.getElementById("added-to-cart");
  var closeButton = document.getElementById("added-cart-close");
  var productImageElement = document.getElementById("cart-product-image");
  var productTitleElement = document.getElementById("cart-product-title");
  var productLinkElement = document.getElementById("cart-product-link");

  addToCartButtons.forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault();

      // Get the product variant ID from the data attribute
      const productVariantId = this.getAttribute("data-product-id");
      console.log(productVariantId);
      showAlert("Product added to Cart!");
      addToCart(productVariantId);
    });
  });

  function addToCart(variantId) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        const productImage = data.image;
        productImageElement.src = productImage;

        productTitleElement.innerText = `"${data.product_title}"`;
        productLinkElement.href = data.url;

        modal.style.display = "block";
        modal.classList.add("show");
        fetchCart();
      })
      .catch((error) => {
        console.error("Error adding product to cart:", error);
      });
  }

  closeButton.addEventListener("click", function () {
    modal.style.display = "none";
    modal.classList.remove("show");
  });

  window.addEventListener("click", function (event) {
    if (event.target == modal) {
      modal.style.display = "none";
      modal.classList.remove("show");
    }
  });
});

/*======================
     Wishlist js
========================*/

document.addEventListener("DOMContentLoaded", function () {
  const currencySymbol = getCurrentCurrencySymbol();
  let isLoading = false;

  function showLoadingSpinner() {
    const loadingSpinner = document.getElementById("loadingSpinner");
    if (loadingSpinner) {
      loadingSpinner.style.display = "flex";
    }
  }

  function hideLoadingSpinner() {
    const loadingSpinner = document.getElementById("loadingSpinner");
    if (loadingSpinner) {
      loadingSpinner.style.display = "none";
    }
  }

  function showEmptyWishlistMessage() {
    const emptyMessage = document.getElementById("emptyWishlistMessage");
    if (emptyMessage) {
      emptyMessage.style.display = "block";
    }
  }

  function hideEmptyWishlistMessage() {
    const emptyMessage = document.getElementById("emptyWishlistMessage");
    if (emptyMessage) {
      emptyMessage.style.display = "none";
    }
  }

  function showWishlistContainer() {
    const wishlistContainer = document.getElementById("wishlistContainer");
    if (wishlistContainer) {
      wishlistContainer.style.display = "flex";
    }
  }

  function updateWishlistButtonState() {
    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    const buttons = document.querySelectorAll(".wishlist-btn");

    buttons.forEach((button) => {
      const buttonHandle = button.getAttribute("data-product-handle");
      if (wishlist.includes(buttonHandle)) {
        button.classList.add("filled");
      } else {
        button.classList.remove("filled");
      }
    });

    updateWishlistCount(); // Update wishlist count whenever the button state is updated
  }

  function updateWishlistCount() {
    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    const wishlistCountElement = document.getElementById("wishlist-count");

    if (wishlistCountElement) {
      wishlistCountElement.textContent = wishlist.length; // Display the wishlist count
    }
  }

  function addToWishlist(productHandle) {
    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

    if (!wishlist.includes(productHandle)) {
      wishlist.push(productHandle);
      localStorage.setItem("wishlist", JSON.stringify(wishlist));
      console.log("Product added to wishlist:", productHandle);
      showAlert("Product added to Wishlist!");
    } else {
    wishlist = wishlist.filter(item => item !== productHandle);
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
    console.log("Product removed from wishlist:", productHandle);
    showAlert("Product removed from Wishlist!", "danger");
    }

    updateWishlistButtonState();
  }

  function removeFromWishlist(productHandle) {
    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

    wishlist = wishlist.filter((handle) => handle !== productHandle);

    localStorage.setItem("wishlist", JSON.stringify(wishlist));

    showAlert("Product removed from Wishlist!", "danger");
    console.log("Product removed from wishlist:", productHandle);

    location.reload();

    updateWishlistButtonState();
  }

  // Load the wishlist on page load
  function loadWishlist() {
    showLoadingSpinner();

    const wishlistContainer = document.getElementById("wishlistContainer");
    if (!wishlistContainer) {
      return;
    }

    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    wishlistContainer.innerHTML = "";
    hideEmptyWishlistMessage();

    if (wishlist.length === 0) {
      hideLoadingSpinner();
      showEmptyWishlistMessage();
      return;
    }

    // Fetch product
    const fetchPromises = wishlist.map((handle) =>
      fetch(`/products/${handle}.js`)
        .then((response) => response.json())
        .then((product) => {
          const productCol = document.createElement("div");
          productCol.className = "col-lg-3 col-md-4 col-6";

          const imageSrc =
            product.images && product.images[0]
              ? product.images[0]
              : "default-image.jpg";

          const productCard = `
            <div class="product-box-3 product-wishlist">
              <div class="img-wrapper">
                <div class="label-block">
                   <a class="label-2 icon wishlist wishlist-remove-btn" href="javascript:void(0);" data-product-handle="${
                     product.handle
                   }">
                      <i class="iconsax" data-icon="trash" aria-hidden="true">
                         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                          <path d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                          <path d="M18.85 9.14001L18.2 19.21C18.09 20.78 18 22 15.21 22H8.79002C6.00002 22 5.91002 20.78 5.80002 19.21L5.15002 9.14001" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                          <path d="M10.33 16.5H13.66" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                          <path d="M9.5 12.5H14.5" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                      </i>
                    </a>
                </div>

                <div class="product-image ratio1_3">
                  <a class="pro-first" href="${product.url}">
                    <img class="img-fluid bg-img" src="${
                      product.images[0]
                    }" alt="${product.title}">
                  </a>
                  ${
                    product.images[1]
                      ? `
                  <a class="pro-sec" href="${product.url}">
                    <img class="img-fluid bg-img" src="${product.images[1]}" alt="${product.title}">
                  </a>`
                      : ""
                  }
                </div>
              </div>
              <div class="product-detail">
                <div class="rating">
                  <div class="custom-vstar-rating-widget" product-id="${
                    product.id
                  }"></div>
                </div>
                <a href="${product.url}">
                  <h6>${product.title}</h6>
                </a>
                <p>
                  ${currencySymbol}${(product.price / 100).toFixed(2)}
                  ${
                    product.compare_at_price
                      ? `<del> ${currencySymbol}${(product.compare_at_price / 100).toFixed(
                          2
                        )} </del> <span> ${Math.round(
                          ((product.compare_at_price - product.price) * 100) /
                            product.compare_at_price
                        )}% </span>`
                      : ""
                  }
                </p>
              </div>
            </div>
          `;

          productCol.innerHTML = productCard;
          wishlistContainer.appendChild(productCol);
        })
        .catch((error) => {
          console.error(
            `Failed to load product data for handle: ${handle}`,
            error
          );
        })
    );

    Promise.all(fetchPromises).finally(() => {
      hideLoadingSpinner();
      showWishlistContainer();
      updateWishlistButtonState();

      wishlistContainer
        .querySelectorAll(".wishlist-remove-btn")
        .forEach((button) => {
          button.addEventListener("click", function (event) {
            const productHandle = button.getAttribute("data-product-handle");
            removeFromWishlist(productHandle);
          });
        });
    });
  }

  document.querySelectorAll(".wishlist-btn").forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      const productHandle = button.getAttribute("data-product-handle");
      addToWishlist(productHandle);
    });
  });

  loadWishlist();
  updateWishlistButtonState();
});

/*========================
    Toast Alert 
==========================*/
function showAlert(message, type = "success") {
  const alertContainer = document.getElementById("alert-container");
  const alert = document.createElement("div");
  alert.className = `alert alert-dismissible fade show text-color-${type} d-flex align-items-center justify-content-between`;
  alert.role = "alert";

  const button = document.createElement("button");
  button.type = "button";
  button.className = `btn text-color-${type} border-0`;
  button.setAttribute("data-bs-dismiss", "alert");
  button.innerText = "×";

  alert.innerHTML = message;
  alert.appendChild(button);
  alertContainer.appendChild(alert);

  setTimeout(() => {
    alert.remove();
  }, 5000);
}

/*========================
    Skeleton Loader
==========================*/
function handleModalOpen() {
  if (document.body.classList.contains("modal-open")) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }
}
const observer = new MutationObserver(handleModalOpen);

observer.observe(document.body, {
  attributes: true,
  attributeFilter: ["class"],
});
setTimeout(() => {
  const loader = document.querySelector(".skeleton_loader");
  if (loader) {
    loader.style.display = "none";
  }
  handleModalOpen();
}, 1500);
handleModalOpen();

/*========================
    Cursor
==========================*/
const stats = new Stats();
stats.showPanel(0);
document.body.appendChild(stats.dom);

const cursor = document.querySelector(".cursor");
const cursorInner = document.querySelector(".cursor-move-inner");
const cursorOuter = document.querySelector(".cursor-move-outer");
const trigger = document.querySelector("button");

let mouseX = 0;
let mouseY = 0;

let innerX = 0;
let innerY = 0;

let outerX = 0;
let outerY = 0;

let loop = null;

document.addEventListener("mousemove", (e) => {
  mouseX = e.clientX;
  mouseY = e.clientY;

  if (!loop) {
    loop = window.requestAnimationFrame(render);
  }
});

trigger.addEventListener("mouseenter", () => {
  cursor.classList.add("cursor--hover");
});

trigger.addEventListener("mouseleave", () => {
  cursor.classList.remove("cursor--hover");
});

function render() {
  stats.begin();

  loop = null;

  innerX = lerp(innerX, mouseX, 0.15);
  innerY = lerp(innerY, mouseY, 0.15);

  outerX = lerp(outerX, mouseX, 0.13);
  outerY = lerp(outerY, mouseY, 0.13);

  const angle = (Math.atan2(mouseY - outerY, mouseX - outerX) * 180) / Math.PI;

  const normalX = Math.min(
    Math.floor((Math.abs(mouseX - outerX) / outerX) * 1000) / 1000,
    1
  );
  const normalY = Math.min(
    Math.floor((Math.abs(mouseY - outerY) / outerY) * 1000) / 1000,
    1
  );
  const normal = normalX + normalY * 0.5;
  const skwish = normal * 0.7;

  cursorInner.style.transform = `translate3d(${innerX}px, ${innerY}px, 0)`;
  cursorOuter.style.transform = `translate3d(${outerX}px, ${outerY}px, 0) rotate(${angle}deg) scale(${
    1 + skwish
  }, ${1 - skwish})`;

  stats.end();

  if (normal !== 0) {
    loop = window.requestAnimationFrame(render);
  }
}

function lerp(start, end, t) {
  return (1 - t) * start + t * end;
}

/*========================
    Tooltip
==========================*/
const tooltipTriggerList = document.querySelectorAll(
  '[data-bs-toggle="tooltip"]'
);
const tooltipList = [...tooltipTriggerList].map(
  (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
);

/*========================
    Discount Code
==========================*/
function copyOfferCode() {
  const offerCode = document.getElementById("offer_code").textContent;

  const tempInput = document.createElement("input");
  tempInput.value = offerCode;
  document.body.appendChild(tempInput);
  tempInput.select();
  document.execCommand("copy");
  document.body.removeChild(tempInput);
  showAlert(`Code has been copied to your clipboard!`);
}

/*========================
    Currency Symbol
==========================*/
window.getCurrentCurrencySymbol = function () {
  const activeElement = document.querySelector(
    '#CountryList .country-item [aria-current="true"]'
  );
  if (!activeElement) {
    return null;
  }

  const currencySymbolElement = activeElement.querySelector(".curreny_symbol");
  if (!currencySymbolElement) {
    return null;
  }

  return currencySymbolElement.textContent.trim();
};

/*========================
    Color Swatch 
==========================*/
var colorItems = document.querySelectorAll(".color-variant li");
colorItems.forEach(function (item) {
  item.addEventListener("click", function (e) {
    colorItems.forEach(function (colorItem) {
      colorItem.classList.remove("active");
    });
    this.classList.add("active");
  });
});